{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Ajouter plus d’images"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Valider"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Précédent"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Revenir à la connexion"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Facturer à la chambre"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Acheter plus"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Annuler"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Fermer"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Terminer l’achat"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Continuer"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Carte de crédit ou de débit"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "TERMINÉ"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Télécharger"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Modifier la commande"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Envoyer"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Oublié"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "J’ai compris"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Suivant (flèche droite)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Précédent (flèche gauche)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Zoom avant/arrière"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Déconnexion"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Connexion"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Galerie de recherche"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "Plus d’images"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Nouvelle commande"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Guide des prix"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Imprimer"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Processus"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Acheter"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Actualiser"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Supprimer"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Supprimer les impressions"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Consulter et acheter"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Sélectionner"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Formats d’impression sélectionnés ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Envoyer le lien"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Envoyer des liens"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Partager"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Rester"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Lecteur Stripe"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Consulter la galerie"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "Consulter Ma galerie"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "Afficher le reçu"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Vous pouvez ajouter plus d’images gratuitement"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Appliquer"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Prix d’achat global : "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Acheter toutes les images pour "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " pour tous"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Détails du panier"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Total du panier"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Paiement"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "code promo"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Carte de crédit ou de débit"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Image(s) numérique(s)"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Images numériques"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Image numérique"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Images numériques"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Images numériques"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Image numérique"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Images numériques"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " et "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Impressions"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Impression"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Impressions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Acheter plus d’images pour obtenir une réduction"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Cette "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " sera fournie gratuitement."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "Un lien vers votre galerie a été envoyé à "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Veuillez sélectionner une ou plusieurs images à acheter avant de passer à la caisse"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "le "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Obtenir "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " pour "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Obtenir toutes les images pour "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Obtenir "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " images pour "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " pour "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " pour "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Guide des prix"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Consultez le Guide des prix pour connaître les prix"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Impressions"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Impression"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Impressions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Acheter"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Acheté"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Achat"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Nous sommes désolés, une erreur s’est produite et le paiement n’a pas pu être effectué. Veuillez réessayer et nous contacter si le problème persiste."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "Le prix standard est de "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " chacune"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Merci pour votre achat !"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Total"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Toutes les images numériques"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Toutes les images et impressions numériques"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Non acheté"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Afficher les photos"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Achetez "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " image"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " images"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " et obtenez une réduction de "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " %"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " % de réduction dès "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " ou plus"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "En utilisant Capturelife, vous acceptez nos"
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Veuillez saisir et confirmer votre mot de passe."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Confirmation du mot de passe"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Contact"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "Courriel ou téléphone"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "Adresse e-mail ou numéro de téléphone"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Veuillez saisir une adresse mail."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Veuillez saisir un mot de passe."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Veuillez saisir une adresse e-mail ou un numéro de téléphone valide."
    }
  ],
  "consumer_enter_valid_email_phone_": [
    {
      "type": 0,
      "value": "Veuillez saisir une adresse e-mail ou un numéro de téléphone valide."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD et toutes les marques, personnages, noms et signes distinctifs associés sont © & ™ Warner Bros. Entertainment Inc. Droits de publication © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Saisissez votre adresse e-mail ou votre numéro de téléphone pour réinitialiser votre mot de passe"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Mot de passe oublié ?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Boutique d’impression"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "Générer le code QR"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Nous sommes désolés, ce lien a expiré. Veuillez saisir votre adresse e-mail ou votre numéro de téléphone pour recevoir un autre lien."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Connexion..."
    }
  ],
  "consumer_logging_in_button": [
    {
      "type": 0,
      "value": "Identification..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Renouez avec vos souvenirs !"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Oups, on dirait qu’il vous manque quelque chose."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "Mes données personnelles"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Ajouter des photos"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Ajouter"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Précédent"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Télécharger"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Accueil"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Déconnexion"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Actualités"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Boutique d’impression"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Profil"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Actualiser"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Partager"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "Votre mot de passe doit comporter au moins "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " caractères."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Mot de passe"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "Votre mot de passe et la confirmation du mot de passe ne correspondent pas."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Veuillez faire une capture d’écran de votre code QR ou cliquez sur le bouton Télécharger ci-dessous"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Réinitialiser le mot de passe"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Réinitialisation du mot de passe..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Sélectionner tout"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "Pour télécharger ou partager une image, appuyez longuement sur l’image pour afficher les options de partage de votre appareil."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Boutique en ligne"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Conditions d’utilisation"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Veuillez saisir l’adresse mail et le mot de passe que vous souhaitez utiliser."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Mettre à jour le mot de passe"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Mettre à jour votre mot de passe"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Mise à jour du mot de passe..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Bienvenue à nouveau !"
    }
  ],
  "error_coupon_already_used": [
    {
      "type": 0,
      "value": "Cannot apply discount code. This discount has already been applied to your account."
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Impossible d’appliquer le code promo. Le total des achats est inférieur au montant minimum requis"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Code promo introuvable"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Veuillez saisir une adresse e-mail réelle."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Veuillez saisir votre adresse mail."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Veuillez remplir les champs ci-dessous."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Réservation introuvable."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "Aucune photo pour ce compte. Veuillez scanner un bracelet qui a été utilisé à la borne photo"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "Aucune photo pour ce compte. Veuillez consulter un photographe ou un assistant"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Carte de crédit ou de débit"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "Adresse e-mail"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Nom de famille"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Mot de passe"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "Pin"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Prix (en "
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Numéro de chambre"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Code secret"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Sélectionner tout"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Déverrouiller toutes les images"
    }
  ],
  "hpx_macao_disclaimer": [
    {
      "type": 0,
      "value": "By using any of the photo shooting props at The Londoner Macao (“Harry Potter – The Exhibition”) you acknowledge and agree that the use of Harry Potter – The Exhibition involves the collection of photographic images of the users (“Photographs” or “Images” and “Users”, respectively)."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "凡使用澳門倫敦人（「哈利波特－展覽」）的任何拍攝道具，即表示閣下知悉並同意使用「哈利波特－展覽」涉及收集使用者的攝影圖像（分別為“照片”或“圖像”及“使用者”）。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "凡使用澳门伦敦人（「哈利波特－展览」）的任何拍摄道具，即表示阁下知悉并同意使用「哈利波特－展览」涉及收集使用者的摄影图像（分别为“照片”或“图像” 及“使用者”）。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You further acknowledge and agree that HPX Macau Limited and its affiliated entities (“the Company”) have engaged a third-party service provider to provide photographic imaging and services solutions for Harry Potter - The Exhibition (“Service Provider”) with servers located in the United States of America (“USA”), in a jurisdiction with different laws and protections than the ones of the Macau Special Administrative Region (“MSAR”)."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下亦知悉並同意HPX 澳門有限公司及其附屬實體（「本公司」）已聘請第三方服務提供者為《哈利波特- 展覽》提供攝影圖像和服務方案（「服務提供者」），其伺服器位於美利堅合眾國（「美國」），該司法管轄的法律和保護與澳門特別行政區（「澳門特別行政區」）是有所不同。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下亦知悉并同意HPX 澳门有限公司及其附属实体（「本公司」）已聘请第三方服务提供者为《哈利波特- 展览》提供摄影圖像和服务方案（「服务提供者」），其伺服器位于美利坚合众国（「美国」），该司法管辖的法律和保护与澳门特别行政区（「澳门特别行政区」）是有所不同。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You understand that the Images are collected so that Users may purchase their photographs in loco and are kept for the duration of the event, until January 5th, 2025, in servers in the USA, after which they are automatically deleted. The Company and the Service Provider take appropriate safety measures to help safeguard the Photographs and Images collected from any unauthorized access and disclosure and only authorized employees of both the Company or the Service Provider have access to them, exclusively for permitted business functions and by using a valid user name and password.  While the Company and the Service Provider use reasonable efforts to prevent loss, misuse, or alteration of the Photographs and Images, no method of storage or transmission over the Internet is completely secure, so the use of Harry Potter - The Exhibition is at Users’ own risk."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下明白收集圖像的目的是為了讓使用者可以即時於場地內購買照片，並在活動期間（直至 2025 年 1 月 5 日）保存在美國的伺服器中，之後它們將自動刪除。 「本公司」及「服務提供者」採取適當安全措施，以保護所收集的照片及圖像免遭任何未經授權的存取及披露，並且只有「本公司」或「服務提供者」的授權員工限於允許的業務功能並透過使用有效的使用者名稱及密碼才能存取這些照片及圖像。 儘管「本公司」及「服務提供者」合理努力防止照片及圖像遺失、被濫用或被篡改，網路上沒有任何儲存或傳輸方式是完全安全的，因此使用 \"哈利-波特--展覽 \"的風險由使用者自行承擔。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下明白收集图像的目的是为了让使用者可以即时于场地内购买照片，并在活动期间（直至 2025 年 1 月 5 日）保存在美国的伺服器中，之后它们将自动删除。「本公司」及「服务提供者」采取适当安全措施，以保护所收集的照片及图像免遭任何未经授权的存取及披露，并且只有「本公司」或「服务提供者」的授权员工限于允许的业务功能并透过使用有效的使用者名称及密码才能存取这些照片及图像。尽管「本公司」及「服务提供者」合理努力防止照片及图像遗失、被滥用或被篡改，网路上没有任何储存或传输方式是完全安全的，因此使用\"哈利-波特--展览\"的风险由使用者自行承担。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "You release, discharge, and agree to hold harmless and defend the Company, the Service Provider, their legal representatives or assignees, and all persons acting under their permission or authority, from any liability by virtue of any reason in connection with the making, collection, processing and storage of the Photographs and Images, including without limitation any claims for libel or violation of any right of image, publicity or privacy."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "閣下免除、解除並同意「本公司」、「服務提供者」、其法定代表或代理人以及在其許可或授權下執行事務的所有人員免於承擔因任何原因而與照片及圖像的製作、收集、處理及儲存有關的任何責任，包括但不限於任何誹謗或侵犯任何肖像權、公開權或隱私權的索賠。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "阁下免除、解除并同意「本公司」、「服务提供者」、其法定代表或代理人以及在其许可或授权下执行事务的所有人员免于承担因任何原因而与照片及图像的制作、收集、处理及储存有关的任何责任，包括但不限于任何诽谤或侵犯任何肖像权、公开权或隐私权的索赔。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "The use of Harry Potter - The Exhibition is governed by the laws of the MSAR and any disputes, claims or differences arising out of or in connection with such use shall be submitted to the Courts of the MSAR."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "《哈利波特 - 展覽》的使用受澳門特別行政區法律管轄，任何因使用而產生或與之相關的爭議、索賠或分歧均應提交澳門特別行政區法院處理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "《哈利波特 - 展览》的使用受澳门特别行政区法律管辖，任何因使用而产生或与之相关的争议、索赔或分歧均应提交澳门特别行政区法院处理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "For requests related with the collection and storage of Photographs and Images please contact the Company through the email address privacy@sands.com.mo. The Company reserves the right to determine whether your request meets legal regulatory requirements and if it can be addressed."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "就有關收集及儲存照片及圖像的請求，請透過電子郵件方式privacy@sands.com.mo與「本公司」聯絡。 「本公司」保留權利以確定閣下的請求是否符合法律法規要求以及是否可以進行處理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "就有关收集及储存照片及图像的请求，请透过电子邮件方式privacy@sands.com.mo与「本公司」联络。「本公司」保留权利以确定阁下的请求是否符合法律法规要求以及是否可以进行处理。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "This Consent has been translated into Chinese. If there is any inconsistency or ambiguity between the English version and the Chinese version, the English version shall prevail."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "本同意書已翻譯成中文。 如果英文版本與中文版本之間存在任何不一致或歧義，以英文版本為準。"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "本同意书已翻译成中文。如果英文版本与中文版本之间存在任何不一致或歧义，以英文版本为准。"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Approbation requise"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Demander de l’aide"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Approuver l’achat"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Indiquez le prix de cet achat."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "Vous serez automatiquement déconnecté dans "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " seconde"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " secondes"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Vous êtes toujours là ?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " images numériques"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " image numérique"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " images numériques"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impressions"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impression"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impressions"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Consulter et acheter"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Appuyez sur "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " pour supprimer une image de votre panier. Appuyez sur "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "TERMINER L’ACHAT"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " pour poursuivre."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Ajouter des images à votre galerie"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Sélectionner les images à acheter"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Appuyez sur les images pour les ajouter à votre galerie. Appuyez sur "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AFFICHER MA GALERIE"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " pour revenir à votre galerie."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Appuyez sur les images pour les ajouter à votre commande. Appuyez sur "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "CONSULTER ET ACHETER"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " pour poursuivre."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Chargement des images..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_enter_access_code": [
    {
      "type": 0,
      "value": "Enter Access Code"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Sélectionner et acheter"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "Votre galerie d’images"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Sélectionner et imprimer"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "Votre galerie d’images"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Appuyez sur l’image pour la sélectionner et l’acheter. Appuyez sur "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " pour continuer."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "Votre galerie est vide. Appuyez sur "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "PLUS D’IMAGES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " dans le coin supérieur droit de l’écran pour parcourir les images disponibles."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Appuyez sur l’icône d’impression sur une image pour la sélectionner et l’imprimer. Appuyer sur le bouton Imprimer pour télécharger les images sélectionnées"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Appuyez sur l’image pour la sélectionner et l’acheter. Appuyez deux fois pour demander une impression. Appuyez sur "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " pour continuer."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Vous avez déverrouillé toutes les images. Appuyez sur "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " pour les supprimer de votre galerie."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Vous avez déverrouillé toutes les images. Appuyez sur une image pour demander une impression. Appuyez sur "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " pour les supprimer de votre galerie."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Ajouter une impression"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Achat numérique"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Impression achetée"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Impression sélectionnée"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Supprimer l’impression"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Sélectionner l’impression"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Vos images"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Sélectionner des images"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "Votre sélection"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Accéder à vos images"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Entrez votre numéro de chambre, votre nom de famille et votre e-mail pour accéder à votre galerie"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Bienvenue !"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD et toutes les marques, personnages, noms et signes distinctifs associés sont © & ™ Warner Bros. Entertainment Inc. Droits de publication © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Veuillez saisir votre adresse e-mail pour poursuivre."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Scannez votre bracelet pour commencer"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Facturer à la chambre"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "Le total ci-dessous sera facturé à votre chambre"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Terminer l’achat"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Votre commande comprend :"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Toutes les ventes sont définitives et les remboursements ne peuvent pas être fournis."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Détails de la commande"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Appuyez sur les images à gauche pour sélectionner l’achat."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Votre panier est vide. Appuyez sur les images pour les ajouter à votre commande."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Votre panier est vide. Appuyer sur "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AJOUTER PLUS D’IMAGES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " pour ajouter plus d’images"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "Vous recevrez vos images par e-mail"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Appuyez deux fois sur l’image pour demander une impression."
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Terminer l’achat"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "Comment souhaitez-vous régler votre achat ?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Guide des prix"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Acheter plus d’images pour obtenir une réduction"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "Le prix standard est de "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " par image"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Vous pouvez ajouter plus d’images gratuitement"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Formats d’impression"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Sélectionner les formats d’impression et les quantités"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Traitement du paiement..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Réductions offertes :"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Forfaits offerts :"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " par image"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Prix standard :"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Total :"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Appuyez sur les images pour les ajouter à votre commande."
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Appuyez sur les images pour les sélectionner ou les désélectionner pour l’achat. Pour ajouter d’autres images à partir de votre sélection, appuyez sur "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "PLUS D’IMAGES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Lecteur non connecté"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Échec du traitement par le lecteur"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Lecteur en veille..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Achat terminé"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "Un lien vers votre galerie a été envoyé à "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Voulez-vous supprimer cette image de votre commande ? Vous devrez la trouver à nouveau en appuyant sur "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "AJOUTER PLUS D’IMAGES"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Chambre "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Chambres "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "Un lien a été envoyé à "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_search_images": [
    {
      "type": 0,
      "value": "Search Images"
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Format"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Impressions sélectionnées"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Moment"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Nombre"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Format d’impression"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Terminer l’achat"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Entrer les informations de paiement"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Bienvenue, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " !"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Bienvenue, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " !"
    }
  ]
}